import {
  Box,
  Button,
  CircularProgress,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Typography,
  createTheme,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterFunc, openModal } from "../../redux/actions/actions";
import TableDetailsModal from "../Modal/TableDetailsModal";

import NoDataFound from "../NoDataFound";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SchoolIcon from "@mui/icons-material/School";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import BadgeIcon from "@mui/icons-material/Badge";
import KeyIcon from "@mui/icons-material/Key";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import RateReviewIcon from "@mui/icons-material/RateReview";
import LockIcon from "@mui/icons-material/Lock";
import HelpIcon from "@mui/icons-material/Help";
import FlagIcon from "@mui/icons-material/Flag";
import LanguageIcon from "@mui/icons-material/Language";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import FeedIcon from "@mui/icons-material/Feed";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { getTheme } from "../../styles/theme";
import { useNavigate } from "react-router-dom";
import { bookingDatas } from "../../pages/MyBookings/data";
import { light } from "@mui/material/styles/createPalette";

import paperBackFirstImg from "../../assets/images/masks/paper-back-1.svg";
import paperBackSecondImg from "../../assets/images/masks/paper-back-2.svg";
import axiosInstance from "../../axiosInstance";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function PaginationTable({
  tableHeader,
  allTableHeader,
  isMobileSm,
  isMobileMd,
}) {
  const { t } = useTranslation();

  const filteredDatas = useSelector((state) => state.filters.filteredListItems); // Filtrelenmiş ürünleri al
  const count = useSelector((state) => state.listItems.count); // Filtrelenmiş ürünleri al
  const myPage = useSelector((state) => state.filters.page); // Filtrelenmiş ürünleri al

  const rawData = filteredDatas;

  const [filteredDatass, setFilteredDatass] = React.useState([]);

  const [page, setPage] = React.useState(myPage);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const pageType = useSelector((state) => state.filters.pageType);
  const loading = useSelector((state) => state.listItems?.loading); // Redux store'dan loading durumunu al

  const selectedFilters = useSelector((state) => state.filters.selectedFilters); // Arama terimini al
  const searchedTerm = useSelector((state) => state.searchTerm.searchTerm); // Arama terimini al
  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );

  const dispatch = useDispatch();

  useEffect(() => {
    setPage(0);
  }, [searchedTerm, selectedFilters]);
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  const handleChangePage = (event, newPage) => {
    // setPage(newPage - 1);
    // dispatch(filterFunc({}, pageType, searchedTerm, selectedBranchesString));

    dispatch(
      filterFunc(
        selectedFilters,
        pageType,
        searchedTerm,
        selectedBranchesString,
        newPage + 1
      )
    );
  };

  useEffect(() => {
    if (myPage) {
      setPage(myPage - 1);
    }
  }, [myPage]);

  const handleOpenModal = (row) => {
    // Dispatch an action to open the modal, with the FilterModal component as the payload
    dispatch(
      openModal(<TableDetailsModal data={row} columns={allTableHeader} />)
    );
  };

  useEffect(() => {
    // Filtreleme sonrası toplam sayfa sayısını hesapla
    const totalPageCount = Math.ceil(count / rowsPerPage);

    // Eğer mevcut sayfa numarası hesaplanan toplam sayfa sayısından büyükse,
    // veya filtrelenmiş veri sayısı sıfırsa (yani hiç veri kalmamışsa),
    // sayfa numarasını otomatik olarak en uygun değere ayarla.
    if (page >= totalPageCount || filteredDatas?.length === 0) {
      setPage(totalPageCount > 0 ? totalPageCount - 1 : 0); // Sayfalar 0'dan başladığı için -1 yapıyoruz.
    }
  }, [count, filteredDatas?.length, rowsPerPage, page]);

  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin
  const theme = getTheme(lightMode); // lightMode değerine göre temayı alın

  const navigate = useNavigate();

  useEffect(() => {
    if (pageType !== "bookings") {
      // Eğer pageType "bookings" değilse, herhangi bir işlem yapma
      setFilteredDatass(filteredDatas);
      return;
    }

    const uniqueInvoices = rawData.reduce((acc, current) => {
      const x = acc.find((item) => item.invoice_id === current.invoice_id);
      if (!x) {
        return acc.concat([current]);
      } else {
        x.details.check_in += `, ${current.details.check_in}`;
        x.details.check_out += `, ${current.details.check_out}`;
        return acc;
      }
    }, []);
    setFilteredDatass(uniqueInvoices);
  }, [rawData]); // filteredDatas değiştiğinde bu useEffect tetiklenir.

  // useEffect(() => {
  //   console.log(filteredDatass[15]?.details?.check_out, "fil datas");
  // }, [filteredDatas]);

  const paraFormat = (number) => {
    const formatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    });
    return formatter.format(number);
  };

  const themeTable = createTheme({
    palette: {
      mode: lightMode ? "light" : "dark", // Modu Redux state'ine bağlayın
    },
    components: {
      MuiTable: {
        styleOverrides: {
          root: {
            border: `1px solid ${lightMode ? "#e0e0e0" : "#515151"}`,
            borderRadius: "1rem",
            overflow: "hidden",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            background: "unset",
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          head: {
            background: lightMode ? "#ffffff !important" : "#1e1e1e !important",
          },

          root: {
            height: "70px",
            "&:nth-child(odd)": {
              background: lightMode ? "#f5f5f5" : "#303030",
            },

            "&:last-child .MuiTableCell-root": {
              borderBottom: "unset",
            },
            "&.MuiTableRow-hover:hover": {
              backgroundColor: lightMode ? "#efefef" : "#232323 !important",
            },
          },
          hover: {
            "&:hover": {
              backgroundColor: "red !important",
            },
          },
        },
      },
    },
  });

  const getIconForColumn = (id) => {
    if (id.includes("phone"))
      return (
        <LocalPhoneIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("school"))
      return (
        <SchoolIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("commission_type"))
      return (
        <CalendarTodayIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("commission_paid_status"))
      return (
        <HelpIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (
      id.includes("date") ||
      id.includes("created") ||
      id.includes("selected") ||
      id.includes("accepted_at") ||
      id.includes("check")
    )
      return (
        <CalendarMonthIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("name"))
      return (
        <BadgeIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("id"))
      return (
        <KeyIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("price") || id.includes("amount"))
      return (
        <CreditCardIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("rate"))
      return (
        <RateReviewIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("occupancy"))
      return (
        <LockIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("status"))
      return (
        <HelpIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("country"))
      return (
        <FlagIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("language"))
      return (
        <LanguageIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("duration"))
      return (
        <TimelapseIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    if (id.includes("overdue"))
      return (
        <HourglassBottomIcon
          sx={{
            fontSize: 20,
            mr: 1,
            color: theme.palette.primary.main,
            top: "3px",
            position: "relative",
          }}
        />
      );
    return null;
  };

  const handleUpdateDiscountRequestStatus = async (data, booleanControl) => {

    const accessToken = localStorage.getItem("accessToken");
    const token = localStorage.getItem("loginUser");

    let payload = {
      status: booleanControl,
    };
    let url = `${process.env.REACT_APP_BASE_URL}discount_request/${data?.id}`;

    try {
      const response = await axiosInstance.patch(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          XRefreshToken: `${token}`,
          "Content-Type": "application/json",
        },
      });

      const updatedItem = response.data;

      // Güncel listedeki datayı bulup değiştiriyoruz
      setFilteredDatass((prevList) =>
        prevList.map((item) =>
          item.id === updatedItem.id ? { ...item, ...updatedItem } : item
        )
      );
    } catch (error) {
      console.error("Something went wrong", error);
    }
  };
  return (
    <>
      {!loading ? (
        <Box sx={{ width: "100%", marginTop: { xs: "1.5rem", md: "3rem" } }}>
          {!filteredDatas?.length ? (
            <NoDataFound />
          ) : (
            <Box
              sx={{
                overflow: "hidden",
                // padding: { xs: "0", md: "2rem" },
                borderRadius: "1rem",
              }}
            >
              <ThemeProvider theme={themeTable}>
                {/* <TableContainer
                  sx={{
                    overflowX: "auto",
                    "&::-webkit-scrollbar": {
                      width: "0.4em",
                      height: "0.4em",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "5rem",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                    },
                  }}
                >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {tableHeader?.map((column, idx) => (
                          <TableCell
                            key={idx}
                            align={"center"}
                            sx={{
                              minWidth: { xs: "130px", md: "fit-content" },
                              fontSize: { xs: "14px", md: "14px" },
                              padding: ".5rem",
                            }}
                          >
                            {column.id.includes("phone") ? (
                              <LocalPhoneIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("school") ? (
                              <SchoolIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("commission_type") ? (
                              <CalendarTodayIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("commission_paid_status") ? (
                              <HelpIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("date") ||
                              column.id.includes("created") ||
                              column.id.includes("selected") ||
                              column.id.includes("accepted_at") ||
                              column.id.includes("check") ? (
                              <CalendarMonthIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("name") ? (
                              <BadgeIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("id") ? (
                              <KeyIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("price") ? (
                              <CreditCardIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("amount") ? (
                              <CreditCardIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("rate") ? (
                              <RateReviewIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("occupancy") ? (
                              <LockIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("status") ? (
                              <HelpIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("country") ? (
                              <FlagIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("language") ? (
                              <LanguageIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("duration") ? (
                              <TimelapseIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : column.id.includes("overdue") ? (
                              <HourglassBottomIcon
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  fontSize: "28px",
                                  marginRight: { xs: "auto", xl: ".5rem" },
                                  marginLeft: { xs: "auto", xl: "0" },
                                  marginBottom: { xs: ".5rem", xl: "0" },
                                  display: { xs: "block", xl: "inline-block" },
                                }}
                              />
                            ) : (
                              ``
                            )}{" "}
                            {column.id === "duration"
                              ? "Duration / Week"
                              : column.label}
                          </TableCell>
                        ))}
                        <TableCell></TableCell>

                        {isMobileSm || isMobileMd ? (
                          <TableCell
                            align={"center"}
                            sx={{
                              minWidth: { xs: "25%", md: "fit-content" },
                              padding: ".5rem",
                            }}
                          ></TableCell>
                        ) : null}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredDatass?.length && tableHeader?.length
                        ? filteredDatass
                            ?.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => {
                              return (
                                <TableRow hover tabIndex={-1} key={row.code}>
                                  {tableHeader?.map((column) => {
                                    let value = row[column.id];
                                    if (
                                      typeof value === "boolean" &&
                                      column.id !== "commission_paid_status"
                                    ) {
                                      value = value ? "Yes" : "No";
                                    } else if (column?.id === "agent_name") {
                                      if (row?.created_by_agent_name) {
                                        value = row?.created_by_agent_name;
                                      } else {
                                        // value = "AGENT";
                                        value = "";
                                      }
                                    }
                                    return (
                                      <TableCell
                                        sx={{
                                          padding: ".6rem",
                                          fontWeight:
                                            column.id === "status" ||
                                            column.id ===
                                              "commission_paid_status"
                                              ? "700"
                                              : "400",
                                          color:
                                            value === "fullypaid" ||
                                            (column.id ===
                                              "commission_paid_status" &&
                                              value)
                                              ? "green"
                                              : value === "partiallypaid"
                                              ? "orange"
                                              : value === "unpaid" ||
                                                (column.id ===
                                                  "commission_paid_status" &&
                                                  !value)
                                              ? "#23416a"
                                              : value === "overpaid"
                                              ? "blue"
                                              : value === "depositpaid"
                                              ? "orange"
                                              : lightMode
                                              ? "black"
                                              : "#ffffff",
                                        }}
                                        key={column.id}
                                        align={"center"}
                                      >
                                        {column.id === "check_out" ||
                                        column.id === "check_in"
                                          ? row?.details[column.id]
                                              .split(", ") // String'i tarih dizisine dönüştür
                                              .reduce(
                                                (acc, date, index, array) => {
                                                  acc.push(date); // Tarihi accumulator'a ekle
                                                  if (
                                                    index + 1 !==
                                                    array.length
                                                  ) {
                                                    // Son tarih değilse
                                                    acc.push(", "); // Tarihler arasına virgül ve boşluk ekle
                                                    if ((index + 1) % 2 === 0) {
                                                      acc.push(
                                                        <br key={index} />
                                                      ); // Her iki tarih arasına <br /> (alt satır) ekle
                                                    }
                                                  }
                                                  return acc;
                                                },
                                                []
                                              )
                                          : column?.format &&
                                            typeof value === "number"
                                          ? column?.format(value)
                                          : column.id === "check_in"
                                          ? row?.details?.check_in
                                          : column.id === "commission_type"
                                          ? row?.commission_type
                                              ?.split("_")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1)
                                              )
                                              .join(" ")
                                          : column.id === "quote_status"
                                          ? row?.quote_status
                                              ?.split("_")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1)
                                              )
                                              .join(" ")
                                          : column.id === "student_name"
                                          ? row?.student_name
                                              ?.split(" ")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1).toLowerCase()
                                              )
                                              .join(" ")
                                          : column.id === "student_school"
                                          ? row?.student_school
                                              ?.split(" ")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1).toLowerCase()
                                              )
                                              .join(" ")
                                          : column.id ===
                                              "commission_paid_status" && value
                                          ? "Paid"
                                          : column.id ===
                                              "commission_paid_status" && !value
                                          ? "Unpaid"
                                          : column.id === "check_out"
                                          ? row?.details?.check_out
                                          : column.id === "gross_price" ||
                                            column.id === "commission_amount" ||
                                            column.id === "invoice_course_price"
                                          ? paraFormat(value)
                                          : value === "fullypaid"
                                          ? "Fully Paid"
                                          : value === "partiallypaid"
                                          ? "Partially Paid"
                                          : value === "depositpaid"
                                          ? "Deposit Paid"
                                          : value === "overpaid"
                                          ? "Over Paid"
                                          : value === "unpaid"
                                          ? "Unpaid"
                                          : value}
                                      </TableCell>
                                    );
                                  })}
                                  {pageType === "quotes" && !isMobileSm ? (
                                    <TableCell
                                      sx={{ padding: ".6rem" }}
                                      align="center"
                                    >
                                      <Button
                                        onClick={() => {
                                          navigate(
                                            `/quotes/${row?.quote_id}/details`,
                                            {
                                              state: {
                                                quote: row,
                                              },
                                            }
                                          );
                                        }}
                                        variant="contained"
                                        sx={{
                                          textTransform: "none",
                                          padding: ".25rem",
                                          borderRadius: "1rem",
                                          backgroundColor: "#23416a !important",
                                          color: "#ffffff",
                                        }} // Düğmenin metninin büyük harf olmasını engelliyoruz
                                      >
                                        Details
                                      </Button>
                                    </TableCell>
                                  ) : pageType === "partner_requests" &&
                                    !isMobileSm ? (
                                    <TableCell
                                      sx={{ padding: ".6rem" }}
                                      align="center"
                                    >
                                      <Button
                                        onClick={() => {
                                          navigate(
                                            `/myrequests/${row?.id}/details`,
                                            {
                                              state: {
                                                request: row,
                                              },
                                            }
                                          );
                                        }}
                                        variant="contained"
                                        sx={{
                                          textTransform: "none",
                                          borderRadius: "1rem",
                                          padding: ".25rem",
                                          backgroundColor: "#23416a !important",
                                          color: "#ffffff",
                                        }} // Düğmenin metninin büyük harf olmasını engelliyoruz
                                      >
                                        Details
                                      </Button>
                                    </TableCell>
                                  ) : null}
                                  {isMobileSm || isMobileMd ? (
                                    <TableCell
                                      sx={{ padding: ".6rem" }}
                                      align="center"
                                    >
                                      <Button
                                        onClick={() => {
                                          handleOpenModal(row);
                                        }}
                                        variant="contained"
                                        sx={{
                                          textTransform: "none",
                                          borderRadius: "1rem",
                                          padding: ".25rem",
                                          backgroundColor: "#23416a !important",
                                        }} // Düğmenin metninin büyük harf olmasını engelliyoruz
                                      >
                                        Details
                                      </Button>
                                    </TableCell>
                                  ) : null}
                                </TableRow>
                              );
                            })
                        : null}
                    </TableBody>
                  </Table>
                </TableContainer> */}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    padding: ".25rem",
                  }}
                >
                  {filteredDatass
                    // ?.slice(
                    //   page * rowsPerPage,
                    //   page * rowsPerPage + rowsPerPage
                    // )
                    ?.map((row, rowIndex) => (
                      <Paper
                        key={rowIndex}
                        elevation={0}
                        sx={{
                          boxShadow: `0 0 2px 0 ${lightMode ? `rgba(145 158 171 / 0.2)` : "#00000040"
                            },0 12px 24px -4px ${lightMode ? `rgba(145 158 171 / 0.12)` : "#00000040"
                            }`,
                          borderRadius: "1rem",
                          padding: "1rem",
                          backgroundColor: lightMode ? "#fff" : "#292929",

                          // backgroundColor: `rgba(${
                          //   lightMode ? "255 255 255" : "28 37 46"
                          // } / 0.9)`,
                          // backgroundImage: `url(${paperBackFirstImg}), url(${paperBackSecondImg})`,
                          // backgroundSize: "50%, 50%",
                          // backgroundRepeat: "no-repeat",
                          // backgroundPosition: "right top, left bottom",
                          // backdropFilter: "blur(20px)",
                          // transition:
                          //   "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                          // outline: 0,

                          // background: lightMode
                          //   ? `linear-gradient(0.25turn, ${theme.palette.primary.light}15, ${theme.palette.primary.light}05, #fff, ${theme.palette.customRed.orange}05, ${theme.palette.customRed.orange}15)`
                          //   : "#1e1e1e",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                            rowGap: 2,
                            columnGap: pageType === "discount_request" ? 8 : 4,
                            // columnGap: 12,

                            padding: ".5rem",
                          }}
                        >
                          {tableHeader.map((column, colIdx) => {
                            let value = row[column.id];

                            if (
                              typeof value === "boolean" &&
                              column.id !== "commission_paid_status"
                            ) {
                              value = value ? "Yes" : "No";
                            } else if (column.id === "agent_name") {
                              value = row?.created_by_agent_name || "";
                            }

                            if (column.id === "student_name" && value) {
                              value = value
                                ?.split(" ")
                                ?.filter(Boolean)
                                ?.map((word) =>
                                  word
                                    ? word[0]?.toUpperCase() +
                                    word?.slice(1)?.toLowerCase()
                                    : ""
                                )
                                ?.join(" ");
                            }

                            if (
                              [
                                "gross_price",
                                "commission_amount",
                                "invoice_course_price",
                              ].includes(column.id)
                            ) {
                              value = paraFormat(value);
                            }

                            if (column.id === "commission_type" && value) {
                              value = value
                                .split("_")
                                .map((w) => w[0].toUpperCase() + w.slice(1))
                                .join(" ");
                            }

                            if (column.id === "quote_status" && value) {
                              value = value
                                .split("_")
                                .map((w) => w[0].toUpperCase() + w.slice(1))
                                .join(" ");
                            }

                            if (column.id === "agency_agent" && value) {
                              value = row[column.id]["agent_name"];
                            }

                            if (
                              column.id === "status" &&
                              pageType === "discount_request" &&
                              value
                            ) {
                              value = row[column.id]
                                .split("_")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ");
                            }

                            if (["check_in", "check_out"].includes(column.id)) {
                              value = row.details?.[column.id]
                                ?.split(", ")
                                ?.reduce((acc, date, i, arr) => {
                                  acc.push(date);
                                  if (i + 1 !== arr.length) {
                                    acc.push(", ");
                                    if ((i + 1) % 2 === 0)
                                      acc.push(<br key={i} />);
                                  }
                                  return acc;
                                }, []);
                            }

                            if (column.id === "commission_paid_status") {
                              value = value ? "Paid" : "Unpaid";
                            }

                            console.log(value, 'VAL HERE 2');

                            if (
                              [
                                "fullypaid",
                                "depositpaid",
                                "depositpending",
                                "deposit_pending",
                                "Deposit Pending",
                                "partiallypaid",
                                "overpaid",
                                "unpaid",
                                "Draft",
                                "Accepted",
                                "Sent",
                                "Declined",
                                "Approved",
                                "Waiting For Approval"
                              ].includes(value)
                            ) {
                              value =
                                value === "fullypaid"
                                  ? t("fullyPaid")
                                  :
                                  value === "Sent" ? t("sent") :
                                    value === "Declined" ? t("declined") :
                                      value === "Accepted" ? t("accepted") :
                                        value === "Approved" ? t("approved") :
                                          value === "Waiting For Approval" ? t("waitingForApproval") :
                                            value === "Draft" ? t("draft") :
                                              value === "depositpending" || value === "deposit_pending" || value === "Deposit Pending" ?
                                                t("depositPending") :
                                                value === "depositpaid"
                                                  ? t("depositPaid")
                                                  : value === "partiallypaid"
                                                    ? t("partiallyPaid")
                                                    : value === "overpaid"
                                                      ? t("overPaid")
                                                      : t("unpaid");
                            }

                            if (
                              column.id === "updated_at" ||
                              column.id === "created_at"
                            ) {
                              value = row[column.id]
                                ? dayjs(row[column.id]).format(
                                  "YYYY-MM-DD HH:mm"
                                )
                                : "-";
                            }

                            if (
                              column.id === "actions" &&
                              pageType === "discount_request"
                            ) {
                              return (
                                <Box
                                  key={colIdx}
                                  flexDirection={"column"}
                                  display={"flex"}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      textTransform: 'capitalize',
                                      borderBottom: "1px solid #efefef",
                                      pb: 1,
                                    }}
                                  >
                                    {getIconForColumn(column.id)}

                                    {t(column.trsText)}
                                  </Typography>
                                  <Box display={"flex"} mt={2}>
                                    <Button
                                      disabled={
                                        row["status"] === "approved" ||
                                        row["status"] === "declined"
                                      }
                                      onClick={() => {
                                        if (
                                          row["status"] !== "approved" &&
                                          row["status"] !== "declined"
                                        ) {
                                          handleUpdateDiscountRequestStatus(
                                            row,
                                            "approved"
                                          );
                                        }
                                      }}
                                      variant="contained"
                                      color="primary"
                                      sx={{
                                        textTransform: "capitalize",
                                        borderRadius: "1rem",

                                        mr: 1,
                                      }}
                                    >
                                      {t("approve")}
                                    </Button>
                                    <Button
                                      disabled={
                                        row["status"] === "approved" ||
                                        row["status"] === "declined"
                                      }
                                      onClick={() => {
                                        if (
                                          row["status"] !== "approved" &&
                                          row["status"] !== "declined"
                                        ) {
                                          handleUpdateDiscountRequestStatus(
                                            row,
                                            "declined"
                                          );
                                        }
                                      }}
                                      variant="contained"
                                      color="error"
                                      sx={{
                                        textTransform: "capitalize",
                                        borderRadius: "1rem",
                                      }}
                                    >
                                      {t("reject")}
                                    </Button>
                                  </Box>
                                </Box>
                              );
                            }

                            return (
                              <Box key={colIdx}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: 600,
                                    borderBottom: "1px solid #efefef",
                                    pb: 1,
                                    textTransform: 'capitalize'
                                  }}
                                >
                                  {getIconForColumn(column.id)}

                                  {t(column.trsText)}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    textTransform: 'capitalize',
                                    minWidth:
                                      column?.id === "agent_name"
                                        ? "max-content"
                                        : "unset",
                                    display: "block",
                                    mt: 2,
                                    // textAlign: "center",
                                    width: "100px",
                                    fontWeight:
                                      column.id === "status" ||
                                        column.id === "commission_paid_status"
                                        ? 700
                                        : 400,
                                    color:
                                      value === t("fullyPaid") ||
                                        value === t("accepted") ||
                                        value === t("overPaid") ||
                                        row[column.id] === "approved"
                                        ? "green"
                                        : value === t("partiallyPaid")
                                          ? "orange"
                                          : value === t("unpaid") ||
                                            value === t("declined") ||
                                            row[column.id] === "declined"
                                            ? pageType === "quotes"
                                              ? "grey"
                                              : "#f44336"
                                            : value === t("draft")
                                              ? pageType === "quotes"
                                                ? "orange"
                                                : "#999"
                                              : value === t("sent") ||
                                                row[column.id] ===
                                                "waiting_for_approval"
                                                ? "#2196f3"
                                                : value === t("depositPaid") ||
                                                  value === t("depositPending")
                                                  ? pageType === "quotes"
                                                    ? "red"
                                                    : "orange"
                                                  : lightMode
                                                    ? "black"
                                                    : "#fff",
                                  }}
                                >
                                  {value ? value : `-`}
                                </Typography>
                              </Box>
                            );
                          })}

                          {/* Actions */}
                          <Box
                            sx={{
                              gridColumn:
                                isMobileSm || isMobileMd ? "1" : "span 4",
                              mt: 2,
                            }}
                          >
                            {pageType === "quotes" && !isMobileSm && (
                              <Button
                                onClick={() =>
                                  navigate(`/quotes/${row?.quote_id}/details`, {
                                    state: { quote: row },
                                  })
                                }
                                variant="contained"
                                sx={{
                                  textTransform: "capitalize",
                                  borderRadius: "1rem",
                                  backgroundColor:
                                    theme.palette.customRed.orange,
                                  color: "#fff",
                                }}
                              >
                                {t("details")}
                              </Button>
                            )}

                            {pageType === "partner_requests" && !isMobileSm && (
                              <Button
                                onClick={() =>
                                  navigate(`/myrequests/${row?.id}/details`, {
                                    state: { request: row },
                                  })
                                }
                                variant="contained"
                                sx={{
                                  textTransform: "capitalize",
                                  borderRadius: "1rem",
                                  backgroundColor:
                                    theme.palette.customRed.orange,
                                  color: "#fff",
                                }}
                              >
                                {t("details")}
                              </Button>
                            )}

                            {/* {(isMobileSm || isMobileMd || pageType === "discount_request") && (
                            <>
                              <Button
                                onClick={() => handleOpenModal(row)}
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  borderRadius: "1rem",
                                  backgroundColor:
                                    theme.palette.customRed.orange,
                                  color: "#fff",
                                }}
                              >
                                Approve
                              </Button>
                              <Button
                                onClick={() => handleOpenModal(row)}
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  borderRadius: "1rem",
                                  backgroundColor:
                                    theme.palette.customRed.orange,
                                  color: "#fff",
                                }}
                              >
                                Reject
                              </Button>
                            </>
                            )} */}
                          </Box>
                        </Box>
                      </Paper>
                    ))}
                </Box>
              </ThemeProvider>
            </Box>
          )}
          {filteredDatass?.length && tableHeader.length ? (
            <Pagination
              // count={Math.ceil(filteredDatass?.length / rowsPerPage)}
              // page={page + 1} // MUI'nin Pagination bileşeni 1 tabanlıdır, bu nedenle +1 eklenir.
              // onChange={(event, newPage) =>
              //   handleChangePage(event, newPage - 1)
              // } // Sayfa değişikliğini işleyin, -1 eklemeyi unutmayın!

              count={Math.ceil(count / rowsPerPage)}
              page={page + 1} // MUI'nin Pagination bileşeni 1 tabanlıdır, bu nedenle +1 eklenir.
              onChange={(event, newPage) =>
                handleChangePage(event, newPage - 1)
              } // Sayfa değişikliğini işleyin, -1 eklemeyi unutmayın!
              variant="outlined"
              shape="rounded"
              sx={{ mt: 10, display: "flex", justifyContent: "center" }} // Üstten biraz boşluk eklemek için
            />
          ) : null}
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            maxWidth: "fit-content",
            position: "relative",
            left: "calc(50% - 20px)",
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
}
